import httpClient from './httpClient';

const END_POINT = '/api/subscriptions';

const getSubscriptionsList = (perPage, page, sort, filterList) =>
    httpClient.get(
        END_POINT +
        '/list' +
        '?itemsPerPage=' +
        perPage +
        '&page=' +
        page +
        sort +
        filterList
    );
const updateSubscription = id => httpClient.put(END_POINT + '/update/' + id, {});
export {
    getSubscriptionsList,
    updateSubscription
};
